var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

var CustomCheckbox = createClass({

  propTypes: {
    value: PropTypes.bool,
    onChange: PropTypes.func
  },

  render() {
    var {value, onChange} = this.props;

    var classes = 'vf-customcheckbox vf-clickable';
    if (value) classes += ' active';

    return (
      <div className={classes} onClick={onChange && onChange}>
        <div className='vf-customcheckbox-content'>
          <div className='icon-checkmark' />
        </div>
      </div>
    );
  }

});

module.exports = CustomCheckbox;
